module.exports = __webpack_public_path__ + "static/novasloth_azonix_logo-1142028c8c2def5c76468f3be3f1ec54.png";